import { Badge } from "~/components/ui/badge";
import type { ReceptionModificationStatus } from "~/types/receptionModification";

const CONFIG: Record<
  ReceptionModificationStatus,
  { label: string; className: string }
> = {
  pending: {
    label: "Pendiente",
    className: "border-amber-200 bg-amber-50 text-amber-700",
  },
  approved: {
    label: "Aprobada",
    className: "border-green-200 bg-green-50 text-green-700",
  },
  rejected: {
    label: "Rechazada",
    className: "border-red-200 bg-red-50 text-red-700",
  },
};

export function ReceptionModificationStatusBadge({
  status,
}: {
  status: ReceptionModificationStatus;
}) {
  const cfg = CONFIG[status];
  return (
    <Badge variant="outline" className={cfg.className}>
      {cfg.label}
    </Badge>
  );
}
